import baseDayjs, { Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/ru'

baseDayjs.locale('ru')
baseDayjs.extend(utc)
baseDayjs.extend(timezone)
baseDayjs.extend(customParseFormat)
baseDayjs.extend(localizedFormat)
baseDayjs.extend(relativeTime)

export const dayjs = baseDayjs

export function serializeDayjs(d: Dayjs) {
  return {
    isValid: d.isValid(),
    iso: d.isValid() ? d.toISOString() : null,
    unixMs: d.valueOf(),
    utcIso: d.utc().isValid() ? d.utc().toISOString() : null,
  }
}
